import { descricaoNomeClassePorId, nomeClasse } from "../../../../utils/mxutils"

export const TypesPesquisa = {
  TIPOCONSULTA: "TIPOCONSULTA",
  RESPONSEOBJ: "RESPONSEOBJ",
  ONLYDATAINSERT: "ONLYDATAINSERT",
  DESTINOCONSULTA: "DESTINOCONSULTA"
}

const INITIAL = {
  objNomeClasse: 0,
  objTipoImagem: 0,
  descricaoNomeClasse: '',
  dataInsert: "",
  destino: "",
  responseObterObj: {
    $id: "",
    Confere: false,
    ErrorMessage: null,
    ID: 0,
    Imagem: null,
    Local: "",
    NomeClasse: 0,
    Numero: "",
    ObjetoId: 0,
    Status: false
  }
}

export default function pesquisaReducer(state = INITIAL, action) {
  switch (action.type) {
    case TypesPesquisa.TIPOCONSULTA:
      return {
        ...state,
        objNomeClasse: action.payload.objNomeClasse,
      }
    case TypesPesquisa.RESPONSEOBJ:
      return {
        ...state,
        dataInsert: action.payload.dataInsert,
        responseObterObj: action.payload.responseObterObj,
        descricaoNomeClasse: descricaoNomeClassePorId(action.payload.responseObterObj?.NomeClasse)
      }
    case TypesPesquisa.ONLYDATAINSERT:
      return {
        ...state,
        dataInsert: action.payload.dataInsert
      }
    case TypesPesquisa.DESTINOCONSULTA:
      return {
        ...state,
        destino: action.payload.destino
      }
    default:
      return state;
  }
}

export const pesquisaActions = {
  selectTipoConsulta,
  resObterObj,
  scanDataInsert,
  setDestinoConsulta
}

function selectTipoConsulta(objNomeClasseParams) {
  return {
    type: TypesPesquisa.TIPOCONSULTA,
    payload: { objNomeClasse: objNomeClasseParams }
  }
}




function resObterObj(res, numero) {
  return {
    type: TypesPesquisa.RESPONSEOBJ,
    payload: { responseObterObj: res, dataInsert: numero }
  }
}

function scanDataInsert(data) {
  return {
    type: TypesPesquisa.ONLYDATAINSERT,
    payload: { dataInsert: data }
  }
}

function setDestinoConsulta(destinoConsulta) {
  return {
    type: TypesPesquisa.DESTINOCONSULTA,
    payload: { destino: destinoConsulta }
  }
}

